import React, { useCallback, useRef } from "react";
import Webcam from "react-webcam";
import { FaCamera } from "react-icons/fa";

const CameraCapture = ({ onCapture }) => {
  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "environment",
  };

  const capture = useCallback((e) => {
    e.preventDefault();
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      onCapture(imageSrc);
    }
  }, [onCapture]);

  return (
    <div className="camera-container position-relative d-flex justify-content-center mt-3">
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        className="img-fluid rounded w-75"
      />
      {/* Bottom-Centered Button */}
      <button
        className="btn btn-primary position-absolute bottom-0 start-50 translate-middle-x rounded-circle d-flex align-items-center justify-content-center shadow mb-3"
        style={{
          width: "60px",
          height: "60px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          border: "none",
        }}
        onClick={capture}
      >
        <FaCamera style={{ fontSize: "1.5rem", color: "black" }} />
      </button>
    </div>
  );
};

export default CameraCapture;
